import { EmployeeSummaryDto } from './employee-summary-dto.model';


export class ClarificationDetailsDto implements IClarificationDetailsDto {
    entryDate!: Date;
    timings!: string | undefined;
    employee!: EmployeeSummaryDto;
    approver!: EmployeeSummaryDto;
    thumbInTime!: Date | undefined;
    thumbOutTime!: Date | undefined;
    empLegalName!: string | undefined;
    clarificationTime!: Date | undefined;
    clarificationRequestDate!: Date | undefined;
    reason!: string | undefined;
    status!: number | undefined;

    constructor(data?: IClarificationDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entryDate = _data["entryDate"] ? new Date(_data["entryDate"].toString()) : <any>undefined;
            this.timings = _data["timings"];
            this.employee = _data["employee"] ? EmployeeSummaryDto.fromJS(_data["employee"]) : <any>undefined;
            this.approver = _data["approver"] ? EmployeeSummaryDto.fromJS(_data["approver"]) : <any>undefined;
            this.thumbInTime = _data["thumbInTime"] ? new Date(_data["thumbInTime"].toString()) : <any>undefined;
            this.thumbOutTime = _data["thumbOutTime"] ? new Date(_data["thumbOutTime"].toString()) : <any>undefined;
            this.empLegalName = _data["empLegalName"];
            this.clarificationTime = _data["clarificationTime"] ? new Date(_data["clarificationTime"].toString()) : <any>undefined;
            this.clarificationRequestDate = _data["clarificationRequestDate"] ? new Date(_data["clarificationRequestDate"].toString()) : <any>undefined;
            this.reason = _data["reason"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ClarificationDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClarificationDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entryDate"] = this.entryDate ? this.entryDate.toISOString() : <any>undefined;
        data["timings"] = this.timings;
        data["employee"] = this.employee ? this.employee.toJSON() : <any>undefined;
        data["approver"] = this.approver ? this.approver.toJSON() : <any>undefined;
        data["thumbInTime"] = this.thumbInTime ? this.thumbInTime.toISOString() : <any>undefined;
        data["thumbOutTime"] = this.thumbOutTime ? this.thumbOutTime.toISOString() : <any>undefined;
        data["empLegalName"] = this.empLegalName;
        data["clarificationTime"] = this.clarificationTime ? this.clarificationTime.toISOString() : <any>undefined;
        data["clarificationRequestDate"] = this.clarificationRequestDate ? this.clarificationRequestDate.toISOString() : <any>undefined;
        data["reason"] = this.reason;
        data["status"] = this.status;
        return data; 
    }
}

export interface IClarificationDetailsDto {
    entryDate: Date;
    timings: string | undefined;
    employee: EmployeeSummaryDto;
    approver: EmployeeSummaryDto;
    thumbInTime: Date | undefined;
    thumbOutTime: Date | undefined;
    empLegalName: string | undefined;
    clarificationTime: Date | undefined;
    clarificationRequestDate: Date | undefined;
    reason: string | undefined;
    status: number | undefined;
}

